import styled from 'styled-components';


export const PieChartLegendContainer = styled.div`
  overflow: scroll;
  align-items: center;
  justify-content: center;
  margin-left: -140px;
  z-index: 10;
  max-height: 400px;
  margin-top: 32px;

 @media screen and (max-width: 490px){
   margin-left: -200px;
  }
`;


export const FormH1 = styled.div`
  color: #cc8f2d;
  font-size: 14px;
  font-weight: bold;
  letter-spacing: 1.4px;
  text-transform: uppercase;
  margin-top: 24px;
  margin-bottom: 5px;

 @media screen and (max-width: 490px){
  font-size: 8px;
    text-align: center;
    margin-left: 6px;
    margin-top: 6px;
    margin-bottom: 6px;
  }
`;

export const LegendHeaderContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export const LegendItemContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export const LegendItem = styled.div`
  color: white;
  font-size: 14px;
  letter-spacing: 1.4px;
  text-align: center;
  
 @media screen and (max-width: 490px){
    text-align: center;
    font-size: 8px;
    margin-left: 6px;
    margin-top: 6px;
    margin-bottom: 6px;
  }
`;

export const ToolTipContainer = styled.div`
  position: absolute;
  top: ${({ top }) => top};
  right: ${({ right }) => right};
  justify-content: center;
  background: black;
  border-radius: 4px;
  max-width: 200px;
  padding: 10px;
  z-index: 98;
  
  @media screen and (max-width: 1090px){
    right: 40px;
    max-width: 120px;
  }
 @media screen and (max-width: 490px){
    right: 120px;
    max-width: 70px;
    font-size: 10px;
  }
`;

export const ToolTipTopLine = styled.div`
  justify-content: center;
  text-align: left;
  color: #cc8f2d;
  margin-bottom: 10px;
  
 @media screen and (max-width: 490px){
    right: 10px;
    font-size: 10px;
  }
`;

export const ToolTipP = styled.div`
  justify-content: center;
  color: #ffffff;
  border-bottom: 2px solid white;
  text-align: left;
  
 @media screen and (max-width: 490px){
    right: 10px;
    font-size: 10px;
  }
`;

export const ToolTipFooter = styled.div`
  color: #cc8f2d;
  width: 100%;
  display: flex;
  justify-content: space-between;

 @media screen and (max-width: 490px){
  right: 10px;
  font-size: 10px;
 }
`;

export const ToolTipControl = styled.button`
  color: #cc8f2d;
  text-align: left;
  background: none;
  border: none;
  @media screen and (max-width: 490px){
    right: 10px;
    font-size: 10px;
  }
`;

export const ToolTipPointer = styled.div`
  position: absolute;
  top: ${({ top }) => top};
  right: ${({ right }) => right};
  height: 0; 
  width: 0;
  border-right: 12px solid black;
  border-top: 14px solid transparent;
  border-bottom: 14px solid transparent;
  z-index: 99;
  
 
 @media screen and (max-width: 490px){
    right: 110px;
    max-width: 80px;
    top: ${({ top }) => top};
    font-size: 10px;
    border-left: 12px solid black;
    border-right: none;
    z-index: 97;
  }
`;
